import './Header.css'
import React from 'react'

function Header() {
  return (
    <div className="Header">
      <h1 className='Header_Title'>Sigma.io</h1>
    </div>
  )
}

export default Header